var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoStackoverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_831)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7333 10.3225H13.2V15.9999H0V10.3225H1.46667V14.5806H11.7333V10.3225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.06507 9.90053L10.2684 11.3657L10.5712 9.97214L3.36787 8.50634L3.06507 9.90053ZM4.01827 6.56259L10.6911 9.57008L11.3127 8.27859L4.63973 5.27111L4.01827 6.56259ZM5.86467 3.39447L11.5217 7.9533L12.4639 6.85847L6.8068 2.29976L5.86467 3.39447ZM9.51627 0.0246582L8.33493 0.874981L12.728 6.59111L13.9093 5.74092L9.51627 0.0246582ZM2.93335 13.1612H10.2667V11.7418H2.93335V13.1612Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStackoverflow);
export default __webpack_public_path__ + "static/media/logo-stackoverflow.7679edafc59b35ecdd95d4342ffda97b.svg";
export { ForwardRef as ReactComponent };